import React, { useState } from 'react';
import { StarIcon, MapPinIcon, UsersIcon, ClockIcon, HeartIcon, ShareIcon, ArrowLeftIcon, ChevronRightIcon } from 'lucide-react';
export function TourDetailHero() {
  const [activeImage, setActiveImage] = useState(0);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [isWishlisted, setIsWishlisted] = useState(false);
  const tourImages = ['https://images.unsplash.com/photo-1527668752968-14dc70a27c95?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80', 'https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1200&q=80', 'https://images.unsplash.com/photo-1531210483974-4f8c1f33fd35?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80', 'https://images.unsplash.com/photo-1508424897381-4fd8755e4b7a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80', 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'];
  const handlePrevImage = () => {
    setActiveImage(prev => prev === 0 ? tourImages.length - 1 : prev - 1);
  };
  const handleNextImage = () => {
    setActiveImage(prev => prev === tourImages.length - 1 ? 0 : prev + 1);
  };
  const handleThumbnailClick = (index: number) => {
    setActiveImage(index);
  };
  const openLightbox = () => {
    setIsLightboxOpen(true);
  };
  const closeLightbox = () => {
    setIsLightboxOpen(false);
  };
  const handleWishlistToggle = () => {
    setIsWishlisted(!isWishlisted);
  };
  const handleShareClick = () => {
    // In a real app, this would use the Web Share API or copy to clipboard
    alert('Tour link copied to clipboard!');
  };
  const handleBackClick = () => {
    // In a real app, this would use router navigation
    window.history.back();
  };
  return <section className="bg-white py-8" data-id="element-1564">
      <div className="container mx-auto px-4" data-id="element-1565">
        {/* Breadcrumb */}
        <div className="mb-4 flex items-center text-sm text-gray-600" data-id="element-1566">
          <button onClick={handleBackClick} className="flex items-center mr-3 text-blue-600 hover:text-blue-800" data-id="element-1567">
            <ArrowLeftIcon size={16} className="mr-1" data-id="element-1568" />
            <span data-id="element-1569">Back</span>
          </button>
          <a href="/" className="hover:text-blue-600" data-id="element-1570">
            Home
          </a>
          <ChevronRightIcon size={14} className="mx-2" data-id="element-1571" />
          <a href="/switzerland" className="hover:text-blue-600" data-id="element-1572">
            Switzerland
          </a>
          <ChevronRightIcon size={14} className="mx-2" data-id="element-1573" />
          <span className="text-gray-900" data-id="element-1574">Swiss Alpine Adventure</span>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8" data-id="element-1575">
          {/* Left column - Image gallery */}
          <div className="lg:col-span-3" data-id="element-1576">
            <div className="relative rounded-lg overflow-hidden" data-id="element-1577">
              {/* Main image */}
              <div className="aspect-[4/3] relative" data-id="element-1578">
                <img src={tourImages[activeImage]} alt="Tour destination" className="w-full h-full object-cover cursor-pointer" onClick={openLightbox} data-id="element-1579" />
                {/* Navigation arrows */}
                <button onClick={e => {
                e.stopPropagation();
                handlePrevImage();
              }} className="absolute left-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-black/50 rounded-full flex items-center justify-center text-white hover:bg-black/70 transition-colors" aria-label="Previous image" data-id="element-1580">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1581">
                    <path d="M15 18l-6-6 6-6" data-id="element-1582" />
                  </svg>
                </button>
                <button onClick={e => {
                e.stopPropagation();
                handleNextImage();
              }} className="absolute right-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-black/50 rounded-full flex items-center justify-center text-white hover:bg-black/70 transition-colors" aria-label="Next image" data-id="element-1583">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1584">
                    <path d="M9 18l6-6-6-6" data-id="element-1585" />
                  </svg>
                </button>
                {/* Image counter */}
                <div className="absolute bottom-4 right-4 px-2 py-1 bg-black/50 text-white text-sm rounded" data-id="element-1586">
                  {activeImage + 1} / {tourImages.length}
                </div>
              </div>
            </div>
            {/* Thumbnails */}
            <div className="mt-4 grid grid-cols-5 gap-2" data-id="element-1587">
              {tourImages.map((image, index) => <div key={index} className={`aspect-[4/3] rounded-md overflow-hidden cursor-pointer ${activeImage === index ? 'ring-2 ring-blue-600' : 'opacity-70 hover:opacity-100'}`} onClick={() => handleThumbnailClick(index)} data-id="element-1588">
                  <img src={image} alt={`Tour thumbnail ${index + 1}`} className="w-full h-full object-cover" data-id="element-1589" />
                </div>)}
            </div>
          </div>
          {/* Right column - Tour summary */}
          <div className="lg:col-span-2" data-id="element-1590">
            <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1591">
              <div className="mb-4" data-id="element-1592">
                <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full mb-2" data-id="element-1593">
                  Adventure Tour
                </span>
                <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-1594">
                  Swiss Alpine Adventure
                </h1>
                <div className="flex items-center text-sm text-gray-600 mb-3" data-id="element-1595">
                  <MapPinIcon size={16} className="mr-1" data-id="element-1596" />
                  <span data-id="element-1597">Zurich → Interlaken → Zermatt</span>
                </div>
                <div className="flex items-center mb-4" data-id="element-1598">
                  <div className="flex mr-1" data-id="element-1599">
                    {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} size={16} className={`${star <= 4.8 ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300 fill-gray-300'}`} data-id="element-1600" />)}
                  </div>
                  <span className="text-sm text-gray-700 mr-1" data-id="element-1601">4.8</span>
                  <span className="text-sm text-gray-600" data-id="element-1602">(234 reviews)</span>
                </div>
                <div className="flex flex-wrap gap-4 mb-4 text-sm" data-id="element-1603">
                  <div className="flex items-center text-gray-700" data-id="element-1604">
                    <ClockIcon size={16} className="mr-1 text-blue-600" data-id="element-1605" />
                    <span data-id="element-1606">7 Days, 6 Nights</span>
                  </div>
                  <div className="flex items-center text-gray-700" data-id="element-1607">
                    <UsersIcon size={16} className="mr-1 text-blue-600" data-id="element-1608" />
                    <span data-id="element-1609">Max 16 travelers</span>
                  </div>
                </div>
              </div>
              <div className="border-t border-gray-200 pt-4 mb-4" data-id="element-1610">
                <h3 className="font-medium text-gray-900 mb-2" data-id="element-1611">
                  Tour Highlights
                </h3>
                <ul className="space-y-1 mb-4" data-id="element-1612">
                  <li className="flex items-start text-sm text-gray-700" data-id="element-1613">
                    <span className="text-blue-600 mr-2" data-id="element-1614">•</span>
                    <span data-id="element-1615">Matterhorn cable car experience</span>
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-1616">
                    <span className="text-blue-600 mr-2" data-id="element-1617">•</span>
                    <span data-id="element-1618">Traditional Swiss village visits</span>
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-1619">
                    <span className="text-blue-600 mr-2" data-id="element-1620">•</span>
                    <span data-id="element-1621">Professional photography guide</span>
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-1622">
                    <span className="text-blue-600 mr-2" data-id="element-1623">•</span>
                    <span data-id="element-1624">Local cuisine tasting</span>
                  </li>
                </ul>
              </div>
              <div className="border-t border-gray-200 pt-4 mb-5" data-id="element-1625">
                <div className="flex items-center mb-1" data-id="element-1626">
                  <span className="text-sm text-gray-500 line-through mr-2" data-id="element-1627">
                    CHF 2,500
                  </span>
                  <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded" data-id="element-1628">
                    24% OFF
                  </span>
                </div>
                <div className="flex items-baseline mb-4" data-id="element-1629">
                  <span className="text-3xl font-bold text-gray-900" data-id="element-1630">
                    CHF 1,899
                  </span>
                  <span className="text-sm text-gray-600 ml-1" data-id="element-1631">per person</span>
                </div>
                <div className="flex flex-col gap-3" data-id="element-1632">
                  <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-md transition-colors" data-id="element-1633">
                    Book Now
                  </button>
                  <div className="flex gap-2" data-id="element-1634">
                    <button onClick={handleWishlistToggle} className={`flex-1 flex items-center justify-center gap-2 py-2 px-4 rounded-md border transition-colors ${isWishlisted ? 'bg-pink-50 border-pink-200 text-pink-600' : 'border-gray-300 text-gray-700 hover:bg-gray-50'}`} data-id="element-1635">
                      <HeartIcon size={18} className={isWishlisted ? 'fill-pink-600' : ''} data-id="element-1636" />
                      <span data-id="element-1637">{isWishlisted ? 'Saved' : 'Save'}</span>
                    </button>
                    <button onClick={handleShareClick} className="flex-1 flex items-center justify-center gap-2 py-2 px-4 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50" data-id="element-1638">
                      <ShareIcon size={18} data-id="element-1639" />
                      <span data-id="element-1640">Share</span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="text-center text-sm text-gray-600" data-id="element-1641">
                <span className="text-green-600 font-medium" data-id="element-1642">
                  🔥 3 people booked
                </span>{' '}
                this tour in the last 24 hours
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Lightbox modal */}
      {isLightboxOpen && <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center" onClick={closeLightbox} data-id="element-1643">
          <div className="relative max-w-4xl max-h-[90vh]" onClick={e => e.stopPropagation()} data-id="element-1644">
            <img src={tourImages[activeImage]} alt="Tour destination" className="max-w-full max-h-[80vh] object-contain" data-id="element-1645" />
            <button onClick={handlePrevImage} className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-black/50 rounded-full flex items-center justify-center text-white hover:bg-black/70 transition-colors" aria-label="Previous image" data-id="element-1646">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1647">
                <path d="M15 18l-6-6 6-6" data-id="element-1648" />
              </svg>
            </button>
            <button onClick={handleNextImage} className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-black/50 rounded-full flex items-center justify-center text-white hover:bg-black/70 transition-colors" aria-label="Next image" data-id="element-1649">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1650">
                <path d="M9 18l6-6-6-6" data-id="element-1651" />
              </svg>
            </button>
            <button onClick={closeLightbox} className="absolute top-4 right-4 w-10 h-10 bg-black/50 rounded-full flex items-center justify-center text-white hover:bg-black/70 transition-colors" aria-label="Close lightbox" data-id="element-1652">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1653">
                <line x1="18" y1="6" x2="6" y2="18" data-id="element-1654" />
                <line x1="6" y1="6" x2="18" y2="18" data-id="element-1655" />
              </svg>
            </button>
            <div className="absolute bottom-4 left-0 right-0 text-center text-white" data-id="element-1656">
              {activeImage + 1} / {tourImages.length}
            </div>
          </div>
        </div>}
      {/* Mobile sticky booking bar */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 lg:hidden z-20" data-id="element-1657">
        <div className="flex items-center justify-between" data-id="element-1658">
          <div data-id="element-1659">
            <div className="text-lg font-bold text-gray-900" data-id="element-1660">
              CHF 1,899
              <span className="text-sm font-normal text-gray-600 ml-1" data-id="element-1661">
                per person
              </span>
            </div>
            <div className="text-sm text-green-600" data-id="element-1662">24% off</div>
          </div>
          <button className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors" data-id="element-1663">
            Book Now
          </button>
        </div>
      </div>
    </section>;
}